// extracted by mini-css-extract-plugin
module.exports = {"walSelect":"WalSelect_walSelect__1G-qW"};